import React, { useEffect } from 'react';
import ZeditHeader from '../components/zedit/ZeditHeader';
import ZeditFooter from '../components/zedit/ZeditFooter';
import ZeditHero from '../sections/zedit/ZeditHero';
import ZeditProducts from '../sections/zedit/ZeditProducts';
import ZeditFAQ from '../sections/zedit/ZeditFAQ';
import ZeditCTA from '../sections/zedit/ZeditCTA';

const ZeditHomePage = () => {
  useEffect(() => {
    document.title = 'Zedit · Tangible Growth for Web3 Companies';
  }, []);

  return (
    // Matches LayerSeek event page palette: bg-[var(--bg-primary)] + neon yellow-green accent.
    // The .glass-theme class is intentionally NOT applied here so existing accent vars cascade.
    <div className="min-h-screen bg-[var(--bg-primary)] text-white relative overflow-hidden">
      {/* Subtle neon accent glows */}
      <div className="absolute top-[-160px] left-[-160px] w-[480px] h-[480px] bg-[var(--accent-primary)] opacity-[0.08] rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-[40%] right-[-260px] w-[560px] h-[560px] bg-[var(--accent-primary)] opacity-[0.06] rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-[-180px] left-[18%] w-[420px] h-[420px] bg-[var(--accent-primary)] opacity-[0.07] rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10">
        <ZeditHeader theme="dark" />
        <main>
          <ZeditHero />
          <ZeditProducts />
          <ZeditFAQ />
          <ZeditCTA />
        </main>
        <ZeditFooter theme="dark" />
      </div>
    </div>
  );
};

export default ZeditHomePage;
